// Real LyphLine workshop photos (Chinook Manufacturing shoot)
const B = 'https://customer-assets-wrfwihn1.emergentagent.net/job_9e1fb140-210f-412f-9430-9687aa3be1b0/artifacts';

export const WORKSHOP_PHOTOS = [
  { src: `${B}/wqcyv3q0_Chinook_Manufacturing_016.jpg`, alt: 'Rebuilding a freeze dryer control housing at the bench' },
  { src: `${B}/iwovappw_Chinook_Manufacturing_013.jpg`, alt: 'Soldering a freeze dryer control board' },
  { src: `${B}/ejjrjjkv_Chinook_Manufacturing_006.jpg`, alt: 'Charging the refrigeration system with dry nitrogen' },
  { src: `${B}/0pohr9t4_Chinook_Manufacturing_003%20%282%29.jpg`, alt: 'Brazing refrigeration lines on a freeze dryer' },
  { src: `${B}/6ubx9nxu_Chinook_Manufacturing_021.jpg`, alt: 'Probing the LyphLine control board during testing' },
  { src: `${B}/wl59l368_Chinook_Manufacturing_018%20%281%29.jpg`, alt: 'Rewiring a freeze dryer control assembly' },
  { src: `${B}/cap8jtdn_Chinook_Manufacturing_014%20%281%29.jpg`, alt: 'Servicing a refrigeration service valve' },
];

// Individual photo helpers for split sections / hero swaps
export const PHOTO = {
  controlHousing: WORKSHOP_PHOTOS[0].src,
  soldering: WORKSHOP_PHOTOS[1].src,
  nitrogen: WORKSHOP_PHOTOS[2].src,
  brazing: WORKSHOP_PHOTOS[3].src,
  boardTest: WORKSHOP_PHOTOS[4].src,
  rewiring: WORKSHOP_PHOTOS[5].src,
  serviceValve: WORKSHOP_PHOTOS[6].src,
};

// Brand linocut illustrations (recolored to petrol/copper palette)
export const ILLUSTRATIONS = [
  { src: '/illustrations/diagnostics.jpg', title: 'Diagnostics', label: 'Full electronic and system diagnostics' },
  { src: '/illustrations/brazing.jpg', title: 'Refrigeration', label: 'Refrigeration and brazing rebuilds' },
  { src: '/illustrations/tech-door.jpg', title: 'Rebuilds', label: 'Complete chamber and door rebuilds' },
  { src: '/illustrations/servicing.jpg', title: 'Service', label: 'Preventive service and tune ups' },
];
